import type { ArticleRow } from '../../../shared/schemas/article';

export type InfiniteListPatternStatus =
  | 'idle'
  | 'loading'
  | 'success'
  | 'loadingMore'
  | 'empty'
  | 'error';

export interface InfiniteListPatternState {
  status: InfiniteListPatternStatus;
  items: ArticleRow[];
  hasMore: boolean;
  errorMessage: string | null;
  loadMoreErrorMessage: string | null;
}

export const INITIAL_INFINITE_LIST_PATTERN_STATE: InfiniteListPatternState = {
  status: 'idle',
  items: [],
  hasMore: false,
  errorMessage: null,
  loadMoreErrorMessage: null,
};

export function infiniteListPatternStateLoading(): InfiniteListPatternState {
  return {
    status: 'loading',
    items: [],
    hasMore: false,
    errorMessage: null,
    loadMoreErrorMessage: null,
  };
}

export function infiniteListPatternStateLoadingMore(
  prev: InfiniteListPatternState,
): InfiniteListPatternState {
  return {
    ...prev,
    status: 'loadingMore',
    loadMoreErrorMessage: null,
  };
}

export function infiniteListPatternStateError(message: string): InfiniteListPatternState {
  return {
    status: 'error',
    items: [],
    hasMore: false,
    errorMessage: message,
    loadMoreErrorMessage: null,
  };
}

export function infiniteListPatternStateFromPage(
  items: ArticleRow[],
  hasMore: boolean,
): InfiniteListPatternState {
  if (items.length === 0) {
    return {
      status: 'empty',
      items: [],
      hasMore: false,
      errorMessage: null,
      loadMoreErrorMessage: null,
    };
  }
  return {
    status: 'success',
    items,
    hasMore,
    errorMessage: null,
    loadMoreErrorMessage: null,
  };
}

export function infiniteListPatternStateAppendPage(
  prev: InfiniteListPatternState,
  items: ArticleRow[],
  hasMore: boolean,
): InfiniteListPatternState {
  return {
    status: 'success',
    items: [...prev.items, ...items],
    hasMore,
    errorMessage: null,
    loadMoreErrorMessage: null,
  };
}

export function infiniteListPatternStateLoadMoreError(
  prev: InfiniteListPatternState,
  message: string,
): InfiniteListPatternState {
  return {
    ...prev,
    status: 'success',
    loadMoreErrorMessage: message,
  };
}
